import { Box, Button, Typography } from '@mui/material'
import React from 'react'

import type { GridGroupAction } from './types'

type Props = {
	actions: GridGroupAction[]
	selectedCount: number
	onAction: (actionKey: string) => void
}

export const GroupActionsBar: React.FC<Props> = ({ actions, selectedCount, onAction }) => {
	if (actions.length === 0 || selectedCount === 0) {
		return null
	}
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				p: 1,
				backgroundColor: '#eef2ff',
				borderBottom: '1px solid #c7d2fe',
			}}
		>
			<Typography variant="body2">{selectedCount} selected</Typography>
			{actions.map((a) => (
				<Button
					key={a.key}
					size="small"
					variant="outlined"
					onClick={() => {
						if (a.confirmMessage !== null && !window.confirm(a.confirmMessage)) {
							return
						}
						onAction(a.key)
					}}
				>
					{a.label}
				</Button>
			))}
		</Box>
	)
}
